import React from "react";
import holidays from '../documents/Holiday List-Students-2024 (1).docx'
const HolidayList =()=>{
    const pdfFiles = [
        { name: ' HGS school Bhopal', url: '../newdocuments/Holiday List 2026 Updated.docx'},
        { name: ' HGS school Bhimtal', url: '../newdocuments/2904/Holiday List 2026 TEMP (1).docx'},
        { name: ' HGS school Anangpur', url: '../newdocuments/2904/Holiday List 2026 (1) (1).docx'},
        { name: ' HGS school Palla Nuh', url: '../newdocuments/Holiday List 2025-26.pdf' },
        { name: ' HGS school Varansi', url:'../disclosure2026/Holiday List 2026 (1).docx' },
        { name: ' HGS school Jammu', url: '../disclosure2026/Holiday List Template 2026.docx'},
        { name: ' HGS school Faridabad', url:'../newdocuments/Holiday List 2026.docx' },
    ]
    return (
        <div className="home_main">
          <div className="pdf-container">
          <table className="pdf-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>School Name</th>
                <th>Links</th>
              </tr>
            </thead>
            <tbody>
              {pdfFiles.map((file, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{file.name}</td>
                  <td>
                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
    
        </div>
      );
}


export default  HolidayList;